import { getCourse } from '$lib/api/courses';
import { error } from '@sveltejs/kit';
import type { LayoutLoad } from './$types';

export const load: LayoutLoad = ({ params, fetch }) => {
  const id = parseInt(params.id);
  if (isNaN(id)) error(404);
  const coursePromise = getCourse(id, fetch);
  return {
    coursePromise,
    meta: {
      title: 'Course',
      activeNav: 'courses',
      breadcrumbs: {
        activeTitle: coursePromise.then(c => c.code),
        items: [
          {
            title: 'Courses & Skills',
            href: '/admin/courses',
          },
        ],
      },
    },
  };
};
